
























import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";

@Component
export default class extends Mixins(MyList) {
  @Prop() stadiumId!: number;

  dispatchType = "powerfailure/list";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "开始停电时间" },
    { title: "来电时间" },
    { title: "停电消息来源" },
    { title: "停电原因" },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  mounted() {
    this.loadData(
      {
        stadium_id: this.stadiumId
      },
      false
    );
  }
}
